import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { Callout } from '@bingads-webui-react/callout';

import { getHistoryButtonStyles } from '../styles/history-button-styles';

function historyClickHandler(siteMap, scope, accountId) {
  scope.save(getRoutePathById(
    siteMap,
    _.isUndefined(accountId) ?
      'mcc-recommendation-history' :
      'baa-recommendation-history'
  ));
}

class historyButton extends React.Component {
  state = { showPopover: false };

  toggle = () => {
    this.setState(state => ({ showPopover: !state.showPopover }));
  }

  render() {
    const {
      i18n, scope, siteMap, classes,
    } = this.props;
    const { aid: accountId } = scope.values;

    return (
      <div className={classNames([
        'recommendation-history-item',
        classes.recommendationHistoryItem,
      ])}
      >
        <Callout
          popoverId="recommendation-history-popover"
          popoverClassName={classes.recommendationHistoryPopover}
          show={this.state.showPopover}
          onClose={this.toggle}
          content={
            <span className={classes.entityContent}>{i18n.getString(_TL_('My applied recommendation history'))}</span>
          }
          placement="bottom"
          closeButton={false}
        >
          <button
            onClick={() => historyClickHandler(siteMap, scope, accountId)}
            onFocus={this.toggle}
            onBlur={this.toggle}
            onMouseOver={this.toggle}
            onMouseOut={this.toggle}
            className={classes.entityContentRecommendationHistory}
            aria-label={i18n.getString(_TL_('My Applied Recommendation History'))}
          >
            <Glyphicon
              className={classes.entityIcon}
              glyph="ba-FullHistory"
            />
          </button>
        </Callout>
      </div>
    );
  }
}

historyButton.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getHistoryButtonStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const HistoryButton = withI18nConsumer(withSiteMap(withScope(withDefaultStyles(historyButton, getHistoryButtonStyles))));

export {
  HistoryButton,
};
